import { render } from "./TotalVessel.vue?vue&type=template&id=41933747&ts=true"
import script from "./TotalVessel.vue?vue&type=script&lang=ts"
export * from "./TotalVessel.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__